<template>
    <v-layout>
        <v-layout row >
            <v-flex xs12 sm6 offset-sm3 v-if="ready">
                <v-card>
                  <v-layout v-if="error">
                      <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
                  </v-layout>
                  <v-alert type="success" dismissible :value="linkSuccess">
                    You will receive an email with a link to reset your password.
                  </v-alert>
                    <v-card-text>
                        <v-container>
                            <form @submit.prevent="requestPassworReset">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                        name="email"
                                        label="Email"
                                        id="email"
                                        v-model="email"
                                        type="email"
                                        required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn :disabled="linkSuccess" block type="submit" color="primary" :loading="loading">Request Password Link</v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
import { createAuth } from '../../firebase'
export default {
  props: ['initialEmail'],
  data () {
    return {
      email: '',
      password: '',
      ready: true,
      loading: false,
      error: null,
      linkSuccess: false
    }
  },
  created () {
    this.email = this.initialEmail
  },
  methods: {
    requestPassworReset () {
      this.loading = true
      createAuth.sendPasswordResetEmail(this.email).then(() => {
        this.loading = false
        this.linkSuccess = true
      }).catch((error) => {
        this.loading = false
        this.error = error
      })
    },
    onDismissed () {
      this.error = null
    }
  }
}
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?a1645a86